import "@/App.css";
import "./styles/landing.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "./pages/LandingPage";
import WarrantyPolicy from "./pages/WarrantyPolicy";
import ServicePolicy from "./pages/ServicePolicy";
import RefundPolicy from "./pages/RefundPolicy";
import { Toaster } from "./components/ui/sonner";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/warranty-policy" element={<WarrantyPolicy />} />
          <Route path="/service-policy" element={<ServicePolicy />} />
          <Route path="/refund-policy" element={<RefundPolicy />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
